import { version as BUNDLED_LEGAL_VERSION } from '@shared/legal.json';

export { BUNDLED_LEGAL_VERSION };

/**
 * The server decides whether the gate is open (`needsLegalConsent`). Native
 * store builds bake a version number; treating that bake as a veto is what
 * locked iOS users out when the API moved first.
 *
 * Fall back to comparing stamps only when talking to an older API that does
 * not send the flag.
 */
export function legalCurrentVersion(payload, bundled = BUNDLED_LEGAL_VERSION) {
    return payload?.legalVersion || bundled;
}

export function needsLegalConsent(user, payload, bundled = BUNDLED_LEGAL_VERSION) {
    if (!user) return false;
    if (typeof payload?.needsLegalConsent === 'boolean') return payload.needsLegalConsent;
    return user.legal?.acceptedVersion !== legalCurrentVersion(payload, bundled);
}

export function acceptStampOk(payload) {
    const stamped = payload?.user?.legal?.acceptedVersion;
    if (!stamped) return false;
    if (typeof payload?.needsLegalConsent === 'boolean') return payload.needsLegalConsent === false;
    if (payload?.legalVersion) return stamped === payload.legalVersion;
    return true;
}
